

export const GET_PURGE_STATUS_REQUESTED = 'purgeStatus/GET_PURGE_STATUS_REQUESTED';
export const GET_PURGE_STATUS_SUCCESS = 'purgeStatus/GET_PURGE_STATUS_SUCCESS';
export const GET_PURGE_STATUS_FAILURE = 'purgeStatus/GET_PURGE_STATUS_FAILURE';
export const RESET_PURGE_STATUS_DATA = 'purgeStatus/RESET_PURGE_STATUS_DATA';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  purgeStatusResult: null,
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_PURGE_STATUS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_PURGE_STATUS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        purgeStatusResult: action.result,
      };
    }
    case GET_PURGE_STATUS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }

    case RESET_PURGE_STATUS_DATA: {
      return {
        ...state,
        purgeStatusResult: action.payload,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getPurgeStatus = () => {
  return {
    types: [GET_PURGE_STATUS_REQUESTED, GET_PURGE_STATUS_SUCCESS, GET_PURGE_STATUS_FAILURE],
    promise: client => client.get('getPurgeStatus')
  };
};

export const resetPurgeStatusData = () => {
  return {
    type: RESET_PURGE_STATUS_DATA,
    payload: null,
  };
};
